<template>
  <div class="referee-container">
    <el-row>
      <el-col :span="8"  style="padding-left: 20px;">
        <el-button type="primary" @click="exportData">导出数据</el-button>
        <el-button @click="goAddReferees">添加裁判记录</el-button>
        <el-button @click="goBatchReferees">批量裁判记录</el-button>
      </el-col>
      <el-col :span="16" >
        <span>裁判等级</span>
        <el-input
          style="width: 80px;margin-right: 10px;"
          v-model="search.refereeLevel"
          @change="quickSearch"
          placeholder=""/>
        <span>执裁场次(>=)</span>
        <el-input
          style="width: 80px;margin-right: 10px;"
          v-model="search.total"
          @change="quickSearch"
          placeholder=""/>
        <span>起止日期</span>
        <el-date-picker
          style="width: 140px;"
          v-model="search.beginDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
        <span>至</span>
        <el-date-picker
          style="width: 140px;"
          v-model="search.endDate"
          type="date"
          placeholder="选择日期">
        </el-date-picker>
        <el-button @click="quickSearch">查询</el-button>
      </el-col>
    </el-row>
    <div style="width: 100%; height: 30px;" ></div>
    <el-table
      v-loading="listLoading"
      :data="refereeList"
      style="width: 100%">
      <el-table-column label="序号" width="50">
        <template slot-scope="scope">
          {{(scope.$index+1) + (pageSize * (currentPage -1))}}
        </template>
      </el-table-column>
      <el-table-column
        prop="trueName"
        width="150"
        label="裁判员姓名">
        <template slot="header" slot-scope="scope">
          <div>裁判员姓名</div>
          <el-input
            v-model="search.trueName"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="mainReferee"
        label="主裁判员">
      </el-table-column>
      <el-table-column
        prop="linesman"
        label="边裁判员">
      </el-table-column>
      <el-table-column
        label="场内裁判统计">
        <template slot-scope="scope">
          {{scope.row.mainReferee*1 + scope.row.linesman*1}}
        </template>
      </el-table-column>
      <el-table-column
        prop="announcer"
        label="宣告">
      </el-table-column>
      <el-table-column
        prop="recorder"
        label="记录">
      </el-table-column>
      <el-table-column
      prop="refereeRecorder"
      label="计罚">
      </el-table-column>
      <el-table-column
      prop="timer"
      label="计时">
      </el-table-column>
      <el-table-column
      prop="assist"
      label="助理">
      </el-table-column>
      <el-table-column
        label="场外裁判统计">
        <template slot-scope="scope">
          {{scope.row.announcer*1 + scope.row.recorder*1 + scope.row.refereeRecorder*1 + scope.row.timer*1 + scope.row.assist*1}}
        </template>
      </el-table-column>
      <el-table-column
        prop="refereeSupervisor"
        label="裁判监督">
      </el-table-column>
      <el-table-column
        prop="total"
        label="执裁统计"
        width="100">
      </el-table-column>
      <el-table-column
        prop="supervisor"
        label="比赛监督">
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>

  import moment from 'moment'
  import { exportOldMatchRefereeData, adminGetOutMatchRefereeStatsList } from '@/api/match'

  export default {
    name: 'RefereeStatsList',
    data() {
      return {
        listLoading: false,
        totalCount: 0, // 默认数据总数
        pageSize: 20, // 每页的数据条数
        currentPage: 1, // 默认开始页面
        refereeList: [],
        leagueId: '',
        search: {
          beginDate: '',
          endDate: ''
        }
      }
    },
    computed: {
    },
    created() {
      this.leagueId = this.$route.params && this.$route.params.id
      this.getList()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getList()
      },
      quickSearch() {
        this.getList()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getList()
      },
      getList() {
        this.listLoading = true
        this.listQuery = {
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          matchId: this.leagueId
        }
        if (this.search.beginDate) {
          this.search.beginDate = moment(this.search.beginDate).format('YYYY-MM-DD')
        }
        if (this.search.endDate) {
          this.search.endDate = moment(this.search.endDate).format('YYYY-MM-DD')
        }
        this.listQuery = Object.assign(this.listQuery, this.search)
        adminGetOutMatchRefereeStatsList(this.listQuery).then((resolve) => {
          const data = resolve.data
          this.listLoading = false
          if(data) {
            this.refereeList = data.list
            this.currentPage = data.pageNum
            this.totalCount = data.count
          }
        })
      },
      exportData() {
        this.listQuery = {
          matchId: this.leagueId
        }
        if (this.search.beginDate) {
          this.search.beginDate = moment(this.search.beginDate).format('YYYY-MM-DD')
        }
        if (this.search.endDate) {
          this.search.endDate = moment(this.search.endDate).format('YYYY-MM-DD')
        }
        this.listQuery = Object.assign(this.listQuery, this.search)
        let params = this.listQuery
        params.pageSize = 9999
        exportOldMatchRefereeData(params).then((resolve) => {
          const data = resolve.data
          if(data && data.url) {
            window.open(process.env.BJH_API + decodeURIComponent(data.url), '_blank')
            this.$message({
              message: '导出数据成功',
              type: 'success',
              showClose: true,
              duration: 1000
            })
          }
        })
      },
      goAddReferees() {
        this.$router.push({
          name: 'OldLeagueRefereeAdd',
          params: {
            id: this.leagueId
          }
        })
      },
      goBatchReferees() {
        this.$router.push({
          name: 'BatchUpdateDetail',
          params: {
            id: this.leagueId
          }
        })
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .referee {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .dashboard-container {
    .el-col {
      span {
        font-size: 14px;
      }
    }
  }
</style>
